import axios from './_nestAxios'

export const getxIdAsEdicion = _id => axios.get(`/plantillasgenerales-contabilidad/${_id}`)

export const getxIdAsDetalles = _id =>
  axios.get(`/plantillasgenerales-contabilidad/${_id}`, {
    params: {
      tipoConsulta: 'detalles'
    }
  })

export const getxOrigenAsSelect = origen =>
  axios.get('/plantillasgenerales-contabilidad', { params: { tipoConsulta: 'select', origen } })

export const nuevo = data => axios.post('/plantillasgenerales-contabilidad', data)

export const actualizarxId = (_id, data) =>
  axios.put(`/plantillasgenerales-contabilidad/${_id}`, data)

export const eliminarxId = _id => axios.delete(`/plantillasgenerales-contabilidad/${_id}`)
